export const getEnvironmentName = () => {
  const hostname = window?.location?.hostname;

  if (hostname.startsWith('app.')) {
    return 'production';
  }
  if (hostname.startsWith('staging.')) {
    return 'staging';
  }
  if (hostname.startsWith('test.')) {
    return 'test';
  }

  return import.meta.env.MODE;
};

export const isProduction = () => {
  return getEnvironmentName() === 'production';
};

export const getCurrentHost = () => {
  return window?.location?.host;
};

export const getCurrentOrigin = () => {
  return window?.location?.origin;
};

export const isDoubleClick = (e: { detail: number }) => e.detail === 2;
